"use client";

import { Shield, TrendingUp, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  icon: Zap,
  title: "No Call-Out Fee",
  description: "We believe in transparent pricing. You only pay for the tyre fitting and repair services you need, with absolutely no hidden call-out charges across Leeds."
}, {
  icon: Shield,
  title: "Local Leeds Experts",
  description: "Our technicians are based right here in Leeds, ensuring a fast response within 30–60 minutes to get you back on the road safely and quickly."
}, {
  icon: TrendingUp,
  title: "24/7 Emergency Support",
  description: "Tyre trouble doesn't stick to a schedule. Our mobile units are available around the clock for emergency tyre fitting and puncture repairs whenever you need us."
}];
export default function KeyBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="228282" id="the-drive-mobile-advantage" className="bg-background text-foreground py-24 px-4 md:px-8 lg:px-16">
      <div ref={ref} className={`mx-auto max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-16 gap-x-8 lg:gap-x-12">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} className="flex flex-col">
                <Icon className="size-10 text-primary mb-4 shrink-0" strokeWidth={2} aria-hidden="true" />
                <h3 className="font-default text-xl font-bold tracking-tight text-foreground mb-2 uppercase">
                  {benefit.title}
                </h3>
                <p className="font-serif text-base text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}